import React from 'react';
import { CQMasterDataStore } from '../../../../store/cq-master-data.store';
import { observer } from 'mobx-react';

export const GridComponentName = (props:any) => {
    const templateObject = CQMasterDataStore.OutputConfig.getStoreData(props.selectedTemplate);
    const iconName = templateObject.iconName ? (templateObject.iconName).replace(':' , '/') : '';
    const actionType = iconName ? iconName.split('/')[0] : '';
    const actionName = iconName ? iconName.split('/')[1] : '';
    return (
        <div className="slds-media slds-media-center">
            <div className="slds-media__figure">
                <span className={`slds-icon_container slds-icon-action-bug`} title="account">
                <img src={`/assets/icons/${iconName}.svg`} alt={`${iconName}`} className="iconStyle" />
                </span>
            </div>
            <div className="slds-media__body">
                <h2 className="slds-text-heading_medium">{templateObject.componentName}</h2>
            </div>
        </div>
    )
}

export const GridTabComponentName = observer(GridComponentName);